<template>
  <TableLayout :permissions="['business:withdrawalorders:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="会员主键" prop="memberId">
        <el-input v-model="searchForm.memberId" placeholder="请输入会员主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态:0=提现申请中:1=提现成功；2=提现失败；" prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入状态:0=提现申请中:1=提现成功；2=提现失败；" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:withdrawalorders:create', 'business:withdrawalorders:delete']">
        <li><el-button type="primary" @click="$refs.operaWithdrawalOrdersWindow.open('新建提现申请记录')" icon="el-icon-plus" v-permissions="['business:withdrawalorders:create']">新建</el-button></li>
        <li><el-button tpe="danger" @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:withdrawalorders:delete']">删除</el-button></li>
      </ul>
      <el-table
          :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="deleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="createUser" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="updateUser" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="会员主键" min-width="100px"></el-table-column>
        <el-table-column prop="amount" label="提现金额(单位:分)" min-width="100px"></el-table-column>
        <el-table-column prop="wxExternalNo" label="微信平台交易订单号" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态:0=提现申请中:1=提现成功；2=提现失败；" min-width="100px"></el-table-column>
        <el-table-column prop="doneTime" label="提现完成时间" min-width="100px"></el-table-column>
        <el-table-column prop="doneInfo" label="完成备注" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:withdrawalorders:update', 'business:withdrawalorders:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaWithdrawalOrdersWindow.open('编辑提现申请记录', row)" icon="el-icon-edit" v-permissions="['business:withdrawalorders:update']">编辑</el-button>
            <el-button type="text" style="color: red;"  @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:withdrawalorders:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaWithdrawalOrdersWindow ref="operaWithdrawalOrdersWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaWithdrawalOrdersWindow from '@/components/business/OperaWithdrawalOrdersWindow'
export default {
  name: 'WithdrawalOrders',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaWithdrawalOrdersWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        memberId: '',
        amount: '',
        wxExternalNo: '',
        status: '',
        doneTime: '',
        doneInfo: ''
      }
    }
  },
  created () {
    this.config({
      module: '提现申请记录',
      api: '/business/withdrawalOrders',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
